<template>
  <div class="outer-container">
    <div class="ucontainer">
      <h2 class="manrope text-center heading_fonts ">
        Monetize Your Talent <br />
        Earn an Average Payment of BDT 17,700+
      </h2>
      <h3 class="manrope text-center pb-5">
        Are you someone who understands the skills and knowledge required
        <br />for someone for Frontend, UX/UI or Data Analyst role?
      </h3>

      <div class="grid-2">
        <div class="">
          <img src="../../assets/homeV2/Group 1025.png" alt="" />
        </div>
        <div class="right">
          <h2>
            Teach online from home and earn money. You get to design your
            curriculum based on the hiring need.
          </h2>
          <div class="home-hero__content-cta-1">
            <router-link to="/host_workshop">
              <a class=" hover  ">Become a Trainer </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.home-hero__content-cta-1 {
  padding-top: 30px;
}
.home-hero__content-cta-1 a {
  font-family: 'Manrope', sans-serif;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 700;

  max-width: 260px;
  min-width: 240px;
  border-radius: 4px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: white;
}
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2px;
  color: #29292b;
}
.outer-container {
  padding-top: 125px;
  padding-bottom: 100px;
}
.grid-2 {
  background-color: #29292b;
  display: grid;
  grid-template-columns: 1fr 1fr;
  place-items: center;
  padding: 30px;
}
.right h2 {
  font: 700 2rem/1.2 'Manrope';
  color: white;
}
@media (max-width: 767.98px) {
  .grid-2 {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
  .grid-2 img {
    max-width: 260px;
  }
  .outer-container {
    padding-top: 60px;
    padding-bottom: 50px;
  }
  .heading_fonts {
    padding: 20px 0;
    font: 800 1.5rem/1.6rem 'Manrope';
    letter-spacing: 1px;
    color: #29292b;
  }
}
</style>
